<template>
    <a-drawer :title="titlePrefix" :visible="visible" :wrap-class-name="drawerWrapClassName" destroy-on-close
              :mask-closable="false" @close="onClose" :width="800">
        <div class="ant-drawer-main">
            <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
                <!--可编辑区域 start-->
                <div class="hidden">
                    <a-form-item label="undefined" name="menuId">
                        <a-input v-model:value="form.menuId"/>
                    </a-form-item>
                    <a-form-item label="type" name="type">
                        <a-input v-model:value="form.type"/>
                    </a-form-item>
                    <a-form-item label="路径类型" name="urlType">
                        <a-radio-group v-model:value="form.urlType">
                            <a-radio :value="1">页面</a-radio>
                            <a-radio :value="2">数据</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item label="请求路径" name="url">
                        <a-row type="flex" :gutter="20">
                            <a-col flex="auto">
                                <a-input v-model:value="form.url" placeholder="请输入请求路径"/>
                            </a-col>
                            <a-col>
                                <a-button type="primary" @click="form.url='javascript:;'">无需跳转</a-button>
                            </a-col>
                        </a-row>
                    </a-form-item>
                </div>
                <a-form-item label="上级菜单" name="parentId">
                    <tree-single-select
                        v-model:value="form.parentId"
                        :options="menuList"
                        title-field="menuName"
                        value-field="menuId"
                        parent-field="parentId"
                        root-value="1628606141145972737"
                    />
                </a-form-item>
                <a-form-item label="菜单编号" name="menuCode">
                    <a-input v-model:value="form.menuCode" placeholder="请输入菜单编号"/>
                </a-form-item>
                <a-form-item label="菜单名称" name="menuName">
                    <a-input v-model:value="form.menuName" placeholder="请输入菜单名称"/>
                </a-form-item>
                <a-form-item label="菜单图标" name="icon">
                    <a-row type="flex" :gutter="20">
                        <a-col flex="auto">
                            <a-input v-model:value="form.icon" placeholder="请输入菜单图标"/>
                        </a-col>
                        <a-col>
                            <a-button type="primary" @click="$refs.iconDrawer.visible=true">选择图标</a-button>
                        </a-col>
                    </a-row>
                </a-form-item>
                <a-form-item label="路由地址" name="identifier">
                    <a-row type="flex" :gutter="20">
                        <a-col flex="auto">
                            <a-input v-model:value="form.identifier" placeholder="请输入路由地址"/>
                        </a-col>
                        <a-col>
                            <a-button type="primary" @click="form.identifier=form.menuCode">协议生成</a-button>
                        </a-col>
                    </a-row>
                </a-form-item>
                <a-form-item label="模块名称" name="urlPrefix">
                    <a-input v-model:value="form.urlPrefix" placeholder="请输入路由地址"/>
                </a-form-item>
                <a-form-item label="排序" name="sort">
                    <a-input-number v-model:value="form.sort" :min="0" :precision="0"/>
                </a-form-item>
                <a-form-item label="描述" name="description">
                    <a-textarea v-model:value="form.describe" placeholder="请输入描述" :auto-size="{minRows:3,maxRows:6}"/>
                </a-form-item>
                <!--可编辑区域 end-->
            </a-form>
        </div>
        <div class="ant-drawer-footer">
            <a-button @click="onClose">取消</a-button>
            <a-button type="primary" @click="onSubmit">确定</a-button>
        </div>
    </a-drawer>
    <icon-drawer ref="iconDrawer" v-model:value="form.icon"/>
</template>
<script>
import IconDrawer from "@/views/sys/menu/components/IconDrawer";
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {sys_menu} from "@/api/adminService";

export default {
    name: "MenuDrawer",
    mixins: [formMixin],
    components: {
        IconDrawer
    },
    props: {
        menuList: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            form: {
                parentId: null,
            },
            rules: {
                menuId: [],
                parentId: [
                    dataCheck.required({}),
                ],
                menuCode: [
                    dataCheck.required({}),
                    dataCheck.remote({
                        url: sys_menu.verifyMenuCode,
                        fieldName: 'menuCode',
                        fnSetParam: () => {
                            return {
                                menuId: this.form.menuId
                            }
                        }
                    })
                ],
                menuName: [
                    dataCheck.required({}),
                ],
                icon: [

                ],
                identifier: [
                    dataCheck.required({})
                ],
                urlPrefix: [],
                type: [
                    dataCheck.required({})
                ],
                urlType: [
                    dataCheck.required({type: 'number'})
                ],
                url: [
                    dataCheck.required({})
                ],
                sort: [
                    dataCheck.required({type: 'number'})
                ],
                description: []
            },
            submitUrl: sys_menu.saveOrUpdate
        }
    },
}
</script>
<style scoped lang="less">
</style>
